import React, { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";
import api, { formatEUR, formatPct, ASSET_ICONS } from "../lib/api";

export default function PriceTicker() {
  const [prices, setPrices] = useState([]);
  const prevRef = useRef({});

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const r = await api.get("/prices");
        if (!mounted) return;
        setPrices(r.data.prices || []);
      } catch (e) { /* ignore */ }
    };
    load();
    const id = setInterval(load, 5000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  return (
    <div className="xch-ink py-2.5 border-t border-white/5" data-testid="price-ticker">
      <Marquee pauseOnHover speed={38} gradient={false} gradientColor="#0B0F19" gradientWidth={40} className="xch-marquee">
        {prices.map((p) => {
          const prev = prevRef.current[p.symbol];
          const flash = prev !== undefined ? (p.price_eur > prev ? "flash-up" : p.price_eur < prev ? "flash-down" : "") : "";
          prevRef.current[p.symbol] = p.price_eur;
          const up = (p.change_24h || 0) >= 0;
          return (
            <div
              key={p.symbol}
              className="flex items-center gap-2.5 px-5 py-0.5 mx-1 rounded-full"
              data-testid={`ticker-item-${p.symbol}`}
            >
              <span
                className="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold text-white shrink-0"
                style={{ backgroundColor: ASSET_ICONS[p.symbol] || "#4F46FF" }}
              >{p.symbol.slice(0, 3)}</span>
              <span className="font-display font-bold text-sm text-white/95">{p.symbol}</span>
              <span className={`font-mono text-sm tabular-nums text-white rounded px-1.5 py-0.5 ${flash}`}>
                {formatEUR(p.price_eur)}
              </span>
              <span className={`font-mono text-xs font-semibold ${up ? "xch-ticker-up" : "xch-ticker-down"}`}>
                {up ? "▲" : "▼"} {formatPct(p.change_24h)}
              </span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
